import React from 'react';
import classnames from 'classnames';

const block = 'airtame-info-message-content';

export type InfoMessageContentProps = React.HTMLAttributes<HTMLDivElement>;

export const InfoMessageContent = ({
  className,
  ...props
}: InfoMessageContentProps): React.ReactElement => {
  const classNames = classnames(className, block);

  return <div className={classNames} {...props} />;
};
